import React from 'react';
import GeneralModal from '../../../../../components/UI/modal/GeneralModal';
import useTags from '../../../../../hooks/useTags';
import renewedPermitModalLang from '../../../../../data/lang/homePage/renewedPermitModal.lang';
import {
    useCloseModalRenewedPermit, useGetModalRenewedAlertState, useIsModalRenewedOpenPermit, useModalRenewedPermitData
} from '../../../../../stores/renewedPermitModal.store';
import DisplayConfirmation from './DisplayConfirmation';
import Button from '../../../../../components/buttons/Button';
import { ReceiptCutoff, Send } from 'react-bootstrap-icons';
import RenewedPermitForm from './RenewedPermitForm';
import useRenewedPermitModalFunctions from '../../../../../hooks/useRenewedPermitModalFunctions';
import AlertUser from '../../../../../components/Alerts/AlertUser';
import ExistBtn from '../../../../../components/buttons/ExistBtn';


const RenewedPermitModal = () => {

    const { submitRenewedPermitForm } = useRenewedPermitModalFunctions();
    const getModalRenewedAlertState = useGetModalRenewedAlertState();
    const renewedPermitData = useModalRenewedPermitData();
    const isOtpModalOpen = useIsModalRenewedOpenPermit();
    const closeModal = useCloseModalRenewedPermit();

    const { alertStatus } = getModalRenewedAlertState;
    const { paymentProcessResult } = renewedPermitData.renewedPermitConfirmation;
    const { receiptUrl, hasReceipt } = paymentProcessResult;
    const renewedPermitStep = renewedPermitData.renewedPermitStep;

    const isLoading = alertStatus === 'loading';

    const generateTag = useTags();
    const modalTitleTag = generateTag(renewedPermitModalLang, 'modal-title');
    const showReceiptBtnTag = generateTag(renewedPermitModalLang, 'buttons.print-receipt-btn-tag');
    const sendFormBtnTag = generateTag(renewedPermitModalLang, 'buttons.send-form-btn-tag');


    return (
        <GeneralModal
            show={isOtpModalOpen}
            closingFunc={closeModal}
            title={modalTitleTag}
            modalSize='S'
            alertUser={<AlertUser state={getModalRenewedAlertState} />}
            body={(
                <>
                    <RenewedPermitForm />
                    <DisplayConfirmation />
                </>
            )}
            footer={
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '0.75rem',
                }}>
                    <ExistBtn onClick={closeModal} />

                    <Button theme='success'
                        show={renewedPermitStep === 'confirmation' && hasReceipt}
                        onClick={handleOpenReceipt}
                        endIcon={<ReceiptCutoff />}
                        text={showReceiptBtnTag}
                    />

                    <Button theme='success'
                        show={renewedPermitStep === 'form'}
                        onClick={submitRenewedPermitForm}
                        endIcon={<Send />}
                        text={sendFormBtnTag}
                        isLoading={isLoading}
                    />

                </div>
            }
        />
    );

    function handleOpenReceipt() {
        window.open(receiptUrl, '_blank');
    }
}

export default RenewedPermitModal;